import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

const BORDER_COLOR = `${colorsPalettes.blue[100]}4E`;

export const ChartImageSectionWrapper = styled(Flex)`
    background-color: ${BORDER_COLOR};
    width: 435px;
    border-radius: 7px;
    padding: 6px;
    position: absolute;
    bottom: -19px;
    right: 180px;
`;

export const ChartImageSection = styled(Flex)`
    background-color: ${colorsPalettes.carbon[0]};
    border-radius: 7px;
    flex-direction: column;
`;

export const ChartImageSectionText = styled(Flex)`
    padding: 10px 12px;
    justify-content: space-between;
    gap: 4px;
`;

// NOTE: No similar fontVariant exists; this is a one time use component in an
// "image" that needs translated text
export const ChartHeaderText = styled.span`
    color: ${colorsPalettes.carbon[500]};
    text-align: center;
    font-feature-settings:
        "liga" off,
        "clig" off;
    font-family: Roboto;
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    line-height: 13px;
`;

// NOTE: No similar fontVariant exists; this is a one time use component in an
// "image" that needs translated text
export const ChartItemText = styled.span`
    color: ${colorsPalettes.carbon[400]};
    font-feature-settings:
        "liga" off,
        "clig" off;
    font-family: "DM Sans";
    font-size: 7px;
    font-style: normal;
    font-weight: 400;
    line-height: 6px;
`;

export const Ellipsis = styled(Flex)<{ $color: string }>`
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: ${({ $color }) => $color};
`;

export const DataSectionWrapper = styled(Flex)`
    background-color: ${BORDER_COLOR};
    width: 148px;
    border-radius: 8px;
    padding: 6px;
    position: absolute;
    bottom: 4px;
    right: 67px;
`;

export const DataSection = styled(Flex)`
    flex-direction: column;
    gap: 6px;
    border-radius: 8px;
    background-color: ${colorsPalettes.midnight[600]};
    padding: 8px 8px 16px 8px;
`;

// NOTE: No similar fontVariant exists; this is a one time use component in an
// "image" that needs translated text
export const DataSectionHeaderText = styled.span`
    color: ${colorsPalettes.carbon[0]};
    font-feature-settings:
        "liga" off,
        "clig" off;
    font-family: "DM Sans";
    font-size: 9px;
    font-style: normal;
    font-weight: 500;
    line-height: 10px;
`;

// NOTE: No similar fontVariant exists; this is a one time use component in an
// "image" that needs translated text
export const DataSectionAmountText = styled(Flex)`
    align-items: center;
    color: ${colorsPalettes.carbon[0]};
    font-feature-settings:
        "liga" off,
        "clig" off;
    font-family: "DM Sans";
    font-size: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 10px;
`;

// NOTE: No similar fontVariant exists; this is a one time use component in an
// "image" that needs translated text
export const DataSectionSubtextText = styled.span`
    color: ${colorsPalettes.green[300]};
    font-feature-settings:
        "liga" off,
        "clig" off;
    font-family: "DM Sans";
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
`;
